export default {
  en: {
    mediumDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  },
  fr: {
    mediumDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  },
  ru: {
    mediumDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  },
  vi: {
    mediumDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  }
};
